var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 24 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.014 7.772c-.032-.073-.812-1.803-2.554-3.544C18.844 2.613 16.067.688 12 .688s-6.844 1.925-8.46 3.54C1.798 5.969 1.018 7.696.986 7.772a.56.56 0 0 0 0 .458c.032.072.812 1.802 2.554 3.543 1.616 1.615 4.393 3.54 8.46 3.54s6.844-1.925 8.46-3.54c1.742-1.741 2.522-3.468 2.554-3.543a.56.56 0 0 0 0-.458M12 14.188c-2.942 0-5.51-1.071-7.636-3.181A12.6 12.6 0 0 1 2.127 8a12.6 12.6 0 0 1 2.237-3.006C6.49 2.884 9.058 1.813 12 1.813s5.51 1.07 7.636 3.181A12.6 12.6 0 0 1 21.873 8c-.597 1.145-3.592 6.188-9.873 6.188m0-10.5a4.313 4.313 0 1 0 0 8.625 4.313 4.313 0 0 0 0-8.625m0 7.5a3.187 3.187 0 1 1 0-6.375 3.187 3.187 0 0 1 0 6.375"
  })));
};
export default SvgEye;